import DynamicConfigSettings from './DynamicConfigSettings';

export default DynamicConfigSettings;
